import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import CompletedImg from '../../../assets/completed.svg';
import Button from '../../../components/Button';
import Link from '../../../components/Link';
import { DateFormats, formatDate } from '../../../utils/utils';
import {
  PROFILE_ROUTE,
  TRANSACTION_HISTORY_ROUTE,
  RETIREMENT_PLANNING_ROUTE,
} from '../../../routes/types';

const SavingEnrollmentCompletedPage = () => {
  return (
    <Container style={{ maxWidth: 680 }}>
      <Container
        className={
          'cnd-custom-container-small my-12 px-0 px-lg-0 border-light-gray rounded-1'
        }
      >
        <div className="d-flex flex-column px-10 py-11 px-lg-11">
          <section className="d-flex justify-content-center">
            <h5 className="m-0">Completed</h5>
          </section>
          <section className="d-flex justify-content-center mt-7">
            <span className="text-sub1 fw-light lh-xs">
              Congratulations, you're on the road to making money!
            </span>
          </section>
          <section className="d-flex justify-content-center mt-7">
            <img
              src={CompletedImg}
              alt="puzzle-img"
              style={{ maxWidth: 200, maxHeight: 220 }}
            />
          </section>
          <section className="d-flex flex-column flex-lg-row justify-content-lg-between mt-11">
            <div className="d-flex justify-content-around justify-content-lg-between width-lg-50-sm-100">
              <div className="d-flex flex-column justify-content-center">
                <span className="text-sub1 fw-normal lh-xs">Submitted</span>
                <span className="text-sub1 fw-light lh-xs">
                  {formatDate(new Date(), DateFormats.MONTH_DAY_YEAR)}
                </span>
              </div>
              <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center">
                  <span className="text-sub1 fw-normal lh-xs">Status</span>
                </div>
                <div>
                  <span className="text-sub1 fw-light lh-xs">Completed</span>
                </div>
              </div>
            </div>
            <Button
              variant="primary"
              className={'order-1 order-lg-3 mt-3 mt-lg-0'}
              size="sm"
            >
              Show Summary
            </Button>
          </section>
        </div>
        <div className="d-flex flex-column px-10 py-11 px-lg-11 border-top-light-gray">
          <section className="d-flex justify-content-start">
            <h5 className="m-0">For your records</h5>
          </section>
          <section className="d-flex justify-content-start mt-7">
            <span className="fw-light text-sub1 lh-xs">
              There are multiple options for retaining a record of this
              transaction.
            </span>
          </section>
          <section className="d-flex flex-column justify-content-start mt-7">
            <Row className="m-0 d-flex justify-content-between">
              <Col className="p-0 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  PDF
                </span>
              </Col>
              <Col className="p-0 col-7 col-lg-9">
                <Link
                  href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                  target={'_blank'}
                >
                  <Button
                    leftIcon={light('file-pdf')}
                    variant="primary-outline"
                    className={'order-1 order-lg-3'}
                    size="sm"
                  >
                    Download/Print
                  </Button>
                </Link>
              </Col>
            </Row>
            <Row className="m-0 d-flex justify-content-between pt-3">
              <Col className="p-0 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  Email
                </span>
              </Col>
              <Col className="p-0 col-7 col-lg-9 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  Based upon your{' '}
                  <span className={'d-inline-block'}>
                    <Link
                      href={`#${PROFILE_ROUTE.slice(0, 9)}communication`}
                      className="text-primary fw-bold"
                      isBlue
                    >
                      Communication Preferences
                    </Link>
                  </span>{' '}
                  you will receive e-mail notification of this transaction
                  within an hour.
                </span>
              </Col>
            </Row>
            <Row className="m-0 d-flex justify-content-between pt-3">
              <Col className="p-0 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  Standard Mail
                </span>
              </Col>
              <Col className="p-0 col-7 col-lg-9 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  You will automatically receive written confirmation of this
                  transaction by U.S. Mail.
                </span>
              </Col>
            </Row>
            <Row className="m-0 d-flex justify-content-between pt-3">
              <Col className="p-0 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  Online
                </span>
              </Col>
              <Col className="p-0 col-7 col-lg-9 d-flex justify-content-start align-items-start">
                <span className="fw-light text-sub1 lh-xs text-light-grey">
                  Your request can be reviewed in{' '}
                  <span className={'d-inline-block'}>
                    <Link
                      href={`#${TRANSACTION_HISTORY_ROUTE}`}
                      isBlue
                      className="text-primary fw-bold"
                    >
                      Transaction History.
                    </Link>
                  </span>
                </span>
              </Col>
            </Row>
          </section>
        </div>
        <div className="d-flex flex-column border-top px-10 py-11 px-lg-11 bg-white rounded-border-bottom">
          <section className="d-flex justify-content-start">
            <h5 className="m-0">Things to consider</h5>
          </section>
          <section className="d-flex justify-content-start mt-7">
            <span className="fw-light text-sub1 lh-xs">
              Now that you've setup your savings, you might want to consider the
              following.
            </span>
          </section>
          <section className="mt-7">
            <div className="lh-xs pt-1 d-flex">
              <FontAwesomeIcon icon={light('check')} className="pe-3" />
              <span className="text-sub1 fw-light">
                Make sure to{' '}
                <span className={'d-inline-block'}>
                  <Link
                    href={`#${PROFILE_ROUTE.slice(0, 9)}beneficiaries`}
                    isBlue
                    className="text-primary fw-bold"
                  >
                    setup your beneficiaries
                  </Link>
                </span>{' '}
                for your 401(k) Savings plan.
              </span>
            </div>
            <div className="lh-xs pt-1 d-flex">
              <FontAwesomeIcon icon={light('check')} className="pe-3" />
              <span className="text-sub1 fw-light">
                Check the{' '}
                <span className={'d-inline-block'}>
                  <Link
                    href={`#${RETIREMENT_PLANNING_ROUTE}`}
                    isBlue
                    className="text-primary fw-bold"
                  >
                    retirement planner
                  </Link>
                </span>{' '}
                to see how you can save enough money for retirement.
              </span>
            </div>
            <div className="lh-xs pt-1 d-flex">
              <FontAwesomeIcon icon={light('check')} className="pe-3" />
              <span className="text-sub1 fw-light">
                Review your{' '}
                <span className={'d-inline-block'}>
                  <Link
                    href={`#${PROFILE_ROUTE.slice(0, 9)}communication`}
                    isBlue
                    className="text-primary fw-bold"
                  >
                    communication preferences
                  </Link>
                </span>{' '}
                so you'll receive an email before each increase on your
                contributions.
              </span>
            </div>
          </section>
        </div>
      </Container>
    </Container>
  );
};

export default SavingEnrollmentCompletedPage;
